import {
  Radar,
  RadarChart,
  PolarGrid,
  Legend,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from "recharts";

export default function ModuleChartRadar({ cData, cOptions }) {
  return (
    <>
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={cData}>
          <PolarGrid />
          <PolarAngleAxis dataKey={cOptions.axis.key} />
          <PolarRadiusAxis domain={cOptions.axis.domain} />
          {cOptions.columns.map((item) => (
            <Radar
              key={item.key}
              name={item.name}
              dataKey={item.key}
              stroke={item.color}
              fill={item.color}
              fillOpacity={0.2}
            />
          ))}
          <Legend />
        </RadarChart>
      </ResponsiveContainer>
    </>
  );
}
